import "./App.css";
import SmoothScroll from "./components/site/SmoothScroll";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import EditorialMarquee from "./components/site/EditorialMarquee";
import Services from "./components/site/Services";
import Signature from "./components/site/Signature";
import Programme from "./components/site/Programme";
import Testimonials from "./components/site/Testimonials";
import FinalCTA from "./components/site/FinalCTA";
import Footer from "./components/site/Footer";
import StickyMobileCTA from "./components/site/StickyMobileCTA";

function App() {
  return (
    <SmoothScroll>
      <div
        className="min-h-screen bg-cream text-olive font-sans antialiased"
        data-testid="site-root"
      >
        <Header />
        <main>
          <Hero />
          <EditorialMarquee />
          <Services />
          <EditorialMarquee reverse speed={22} />
          <Signature />
          <Programme />
          <Testimonials />
          <FinalCTA />
        </main>
        <Footer />
        <StickyMobileCTA />
      </div>
    </SmoothScroll>
  );
}

export default App;
